const primaryMain = '#000000';
const primaryMainOpacity = 'rgba(0, 0, 0, 0.9)';
const secondaryMain = '#F26724';
const secondaryMainOpacity = 'rgba(242, 103, 36, 0.5)';
const secondaryLight = '#000000';
const tertiaryMain = '#6D6E71';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
